import useApi from '../utils/axios-pettitions';
import { newToast } from '../components';
import { CustomFilters } from '../types/types.system';

export const useApiInformedConsents = () => {
  const { runApi, runApiFormData } = useApi();

  // Obtener configuración / listado con filtros
  const getData = async (filters: CustomFilters[]) => {
    return runApi('InformedConsents/getData', 'POST', null, filters).then((res) => {
      if (res.internalCode >= 200) {
        return [];
      } else {
        return res.data;
      }
    });
  };

  // Create
  const createConsent = async (data: any) => {
    const res = await runApi('InformedConsents/CreateConsentimiento', 'POST', null, data);
    if (res.internalCode >= 200) {
      return null;
    }
    newToast('SUCCESS', res.message, 3);
    return res.data;
  };

  // Get all
  const getConsents = async () => {
    const res = await runApi('InformedConsents/GetConsentimientos', 'GET', null, null);
    if (res.internalCode >= 200) {
      newToast('ERROR', res.message, 5);
      return [];
    }
    return res.data;
  };

  // Update
  const updateConsent = async (data: any) => {
    const res = await runApi('InformedConsents/UpdateConsentimiento', 'POST', null, data);
    if (res.internalCode >= 200) {
      newToast('ERROR', res.message, 5);
      return null;
    }
    newToast('SUCCESS', res.message, 3);
    return res.data;
  };

  // Delete
  const deleteConsent = async (id: number) => {
    // backend controller uses HttpDelete, but client helper only supports GET/POST so we call POST here as other APIs do
    const res = await runApi('InformedConsents/DeleteConsentimiento', 'POST', { id }, null);
    if (res.internalCode >= 200) {
      newToast('ERROR', res.message, 5);
      return false;
    }
    newToast('SUCCESS', res.message, 3);
    return true;
  };

  // Sign document (file upload + metadata via form)
  // file: File, data: object -> UploadConsentFileRequest
  const signDocument = async (data: any) => {    
    const res = await runApi('InformedConsents/SignDocument', 'POST', null, data);
    if (res.internalCode >= 200) {
      newToast('ERROR', res.message, 5);
      return null;
    }
    newToast('SUCCESS', res.message, 3);
    return res.data;
  };

    const SignDocumentAutorize = async (data: any) => {    
    const res = await runApi('InformedConsents/SignDocumentAutorize', 'POST', null, data);
    if (res.internalCode >= 200) {
      newToast('ERROR', res.message, 5);
      return null;
    }
    newToast('SUCCESS', res.message, 3);
    return res.data;
  };

  // Fill format (create filled format)
  const fillFormat = async (data: any) => {
    const res = await runApi('InformedConsents/FillFormat', 'POST', null, data);
    if (res.internalCode >= 200) {
      newToast('ERROR', res.message, 5);
      return null;
    }
    newToast('SUCCESS', res.message, 3);
    return res.data;
  };

  // Get by order id
  const getConsentByIdOrder = async (IdOrden: number) => {
    const res = await runApi('InformedConsents/GetConsentimientoByIdOrder', 'GET', { IdOrden }, null);
    if (res.internalCode >= 200) {
      newToast('ERROR', res.message, 5);
      return null;
    }
    return res.data;
  };

  // PutSended: type, idOrder, IdCst
  const putSended = async (type: any, idOrder: number, IdCst: number) => {
    const res = await runApi('InformedConsents/PutSended', 'POST', null, { type, idOrder, IdCst });
    if (res.internalCode >= 200) {
      newToast('ERROR', res.message, 5);
      return false;
    }
    newToast('SUCCESS', res.message, 3);
    return true;
  };

  // UpdateFormat
  const updateFormat = async (data: any) => {
    const res = await runApi('InformedConsents/UpdateFormat', 'POST', null, data);
    if (res.internalCode >= 200) {
      newToast('ERROR', res.message, 5);
      return null;
    }
    newToast('SUCCESS', res.message, 3);
    return res.data;
  };

  // CreateConsentimientoByOrder
  const CreateConsentimientoByOrder = async (data: any) => {
    const res = await runApi('InformedConsents/CreateConsentimientoByOrder', 'POST', data, null);
    if (res.internalCode >= 200) {
      return null;
    }
    newToast('SUCCESS', res.message, 3);
    return res.data;
  };

  return {
    getData,
    createConsent,
    getConsents,
    updateConsent,
    deleteConsent,
    signDocument,
    SignDocumentAutorize,
    fillFormat,
    getConsentByIdOrder,
    putSended,
    updateFormat,
    CreateConsentimientoByOrder,
  };
};
